import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import auth from "./auth";
import disclaimer from "./disclaimer";
import master from "./master";
import centralModals from "./central-modal";
import suitabilityModal from "./modals/suitability";
import product from "./product";
import customer from "./customer";
import subscription from "./subscription";
import register from "./register";
import primaryHistoryReducer from "./history-primary";
import secondaryHistoryReducer from "./history-secondary";
import structureNoteHistoryReducer from "./history-structure-note";
import withholdingTaxReducer from "./history-withholding-tax";
import ultrahighConstantReducer from "./ultrahigh-constant";
import loader from "./loader";
import buyFund from "./buy-sell-switching/buy-fund";
import sellFund from "./buy-sell-switching/sell-fund";
import switchFund from "./buy-sell-switching/switch-fund";
import transFund from "./buy-sell-switching/transaction-fund";
import pwm from "./pwm";
import redirect from "./redirect";
import programSection from "./program-section";
import portfolio from "./portfolio";
import secondMarket from "./second-market";
import ultrahighHome from "./ultrahigh-home";
import fund from "./fund";
import research from "./research";
import modelPortfolio from "./model-portfolio";
import structureNote from "./structure-note";
import perpBond from "./perp-bond";
import lombard from "./lombard";
import routerPageStack from "./router-page-stack";
import app from "./app";
import primaryPort from "./primary-port";
import notification from "./notification";
import announcement from "./announcement";

const createRootReducer = (history) =>
  combineReducers({
    [app.name]: app.reducer,
    router: connectRouter(history),
    loader,
    modal: combineReducers({
      [centralModals.name]: centralModals.reducer,
      [suitabilityModal.name]: suitabilityModal.reducer,
    }),
    auth,
    disclaimer,
    constant: combineReducers({
      master,
      ultrahigh: ultrahighConstantReducer,
    }),
    product,
    primary: combineReducers({
      [primaryPort.name]: primaryPort.reducer,
    }),
    customer,
    subscription,
    ultrahigh: combineReducers({
      home: ultrahighHome.reducer,
      pwm: combineReducers({
        buySellSwitching: combineReducers({
          buy: buyFund,
          sell: sellFund,
          [switchFund.name]: switchFund.reducer,
          [transFund.name]: transFund.reducer,
        }),
      }),
      [portfolio.name]: portfolio.reducer,
      [fund.name]: fund.reducer,
      [modelPortfolio.name]: modelPortfolio.reducer,
    }),
    register,
    history: combineReducers({
      primary: primaryHistoryReducer,
      secondary: secondaryHistoryReducer,
      withholdingTax: withholdingTaxReducer,
      structureNote: structureNoteHistoryReducer,
    }),
    pwm,
    [redirect.name]: redirect.reducer,
    [programSection.name]: programSection.reducer,
    secondMarket,
    [research.name]: research.reducer,
    [structureNote.name]: structureNote.reducer,
    [perpBond.name]: perpBond.reducer,
    [lombard.name]: lombard.reducer,
    [routerPageStack.name]: routerPageStack.reducer,
    notification,
    [announcement.name]: announcement.reducer,
  });

export default createRootReducer;
